import React from 'react';

// Shown after a resident signs in on another association's web address. Their
// session here has already been signed out (AuthContext); this points them home.
export function WrongAssociation({ mismatch, onDismiss }) {
  const homeLabel = mismatch?.homeName || 'your community';

  return (
    <main className="min-h-screen bg-main-bg px-6 py-12 font-sans flex items-center justify-center">
      <section className="w-full max-w-md rounded-2xl bg-white border border-amber-100/30 warm-tactile-shadow p-8 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-section-bg">
          <span className="material-symbols-outlined text-secondary" style={{ fontSize: '32px' }}>location_away</span>
        </div>
        <h1 className="text-xl font-bold tracking-tight text-primary-dark mb-2">
          This account belongs to {homeLabel}
        </h1>
        <p className="text-sm font-medium leading-relaxed text-slate-500 mb-8">
          You signed in on the {mismatch?.currentName || 'another community'} portal. Each community has its own
          address; sign in at yours to see your documents, messages and neighbors.
        </p>
        <div className="flex flex-col gap-3">
          {mismatch?.homeUrl && (
            <a
              href={mismatch.homeUrl}
              className="bg-secondary text-white px-8 py-3.5 rounded-full font-bold hover:brightness-110 active:scale-95 transition-all"
            >
              Go to {homeLabel}
            </a>
          )}
          <button
            type="button"
            onClick={onDismiss}
            className="border border-secondary text-secondary px-8 py-3.5 rounded-full font-bold hover:bg-secondary hover:text-white transition-all"
          >
            Back to sign in
          </button>
        </div>
      </section>
    </main>
  );
}

export default WrongAssociation;
